
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>Selina will Gerechtigkeit</h4>
    <p>
  Im Februar 2020, konfrontiert mit den Recherchen, geben sich die meisten involvierten Personen schweigsam. «Da es sich
  strafrechtlich um ein noch laufendes Verfahren handelt, möchte ich hierzu derzeit keine Angaben machen», sagt der
  Therapeut, der William W. in den letzten zwei Jahren behandelte. Die beiden externen Experten, die den
  Untersuchungsbericht verfasst haben, wurden bei der Auftragserteilung einer Schweigepflicht unterstellt. «Unsere
  Feststellungen und Schlussfolgerungen haben wir im Auftrag des Regierungsrates an einer Medienkonferenz erläutert»,
  schreiben sie auf Anfrage. «Wir sind nicht befugt, darüber hinaus Auskünfte zu erteilen.» Als der Tamedia
  Recherchedesk den Solothurner Regierungsrat mit Fragen konfrontiert, gibt dieser sich plötzlich transparent und will
  nun doch Einsicht in den Bericht ermöglichen. Allerdings verschickt er am Ende nicht einmal die Hälfte der Seiten an
  die Redaktion, zum Teil massiv geschwärzt. Die Solothurner Staatsanwaltschaft beantwortet lediglich eine
  organisatorische Frage zum Prozess: «Der Zeitpunkt der Hauptverhandlung ist noch nicht bekannt», sagt Mediensprecherin
  Cony Brand. Thomas Fingerhuth, der neue Verteidiger von William W., sagt: «William W. bestreitet nach wie vor alle
  Vorwürfe.» Für den 46-Jährigen gilt die Unschuldsvermutung.
    </p>
    <Image source='Untersuchungsbericht, geschwärzt durch die Regierung. (RD)' file={require('images/schwarz.png')} mdxType="Image" />
    <p>
  Auf konkrete Fragen gehen der Regierungsrat, das Innen- und das Justizdepartement nicht ein. Andrea Affolter,
  Medienbeauftragte der Staatskanzlei, verweist stattdessen auf folgende Passage in der Zusammenfassung des
  Expertenberichts. «Die Vollzugsbehörde schöpfte ihren Spielraum mit geschütztem Wohn- und Arbeitsrahmen, enger
  Zusammenarbeit mit der Bewährungshilfe, elektronischer Überwachung, forensisch-psychiatrischer Behandlung,
  kontrollierter Drogen- und Alkoholabstinenz sowie Ausschreibung im polizeilichen Fahndungssystem maximal aus.» Alle
  involvierten Mitarbeiter hätten ihre Aufgaben «engagiert» wahrgenommen. «Die ambulante Massnahme wurde mit sehr
  grossem Ressourcenaufwand vollzogen sowie trotz zahlreicher Regelverstösse durch William W. und häufigen
  Vollzugsschwierigkeiten aufrecht erhalten.»
    </p>
    <p>
  Alternativ hätte man die Übung auch viel früher abbrechen können. Dann wäre laut Bericht aber ungewiss gewesen, ob der
  Mann direkt verwahrt werden darf. Die juristischen Hürden seien hoch, «auch wenn neue sexuelle Handlungen mit Kindern
  zu befürchten sind». Also hätten die Behörden zuerst auf die Neubeurteilung durch den Gutachter warten wollen. «Ohne
  neues Gutachten, welches das ambulante Betreuungs- und Kontrollsetting als definitiv nicht Erfolg versprechend
  beurteilte, sahen Vollzugsbehörde und Staatsanwaltschaft keine Chance, dass ein Antrag auf Verwahrung gutgeheissen und
  William W. sofort in Sicherheitshaft genommen werden könnte.»
    </p>
    <p>
  Also blieb der Mann in Freiheit. An fünf Kindern zwischen 4 und 13 Jahren soll er sich dort laut Staatsanwaltschaft
  vergangen haben. «Ich habe vor Jahren gewarnt, dass wieder etwas passiert, wenn er draussen ist. Aber die Behörden
  haben mir versichert, dass sie ihn streng kontrollieren», sagt Selina. Sie will Gerechtigkeit, fordert Konsequenzen.
  «Damit meine ich nicht William W., sondern den Kanton. Die Verantwortlichen sollen endlich für ihre Fehler gerade
  stehen.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;